import { useEffect, useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { useAppTranslations } from '@treneo/shared/i18n';

import { useAppWatch } from '../hooks';

import { PasswordField } from './password-form-field';

const formFieldNames = {
  password: 'password',
  confirmPassword: 'confirmPassword'
} as const;

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Form may be IChangePasswordRequest, IRegisterRequest, etc.; all have password/confirmPassword
  formContext: UseFormReturn<any>;
  passwordLabel?: string;
  confirmPasswordLabel?: string;
};

export const PasswordAndConfirmPasswordFields = ({
  formContext,
  passwordLabel,
  confirmPasswordLabel
}: Readonly<Props>) => {
  const { t } = useAppTranslations();

  const [passwordsNotMatch, setPasswordsNotMatch] = useState<boolean>();

  const passwordValue = useAppWatch({
    control: formContext.control,
    name: formFieldNames.password
  });
  const confirmPasswordValue = useAppWatch({
    control: formContext.control,
    name: formFieldNames.confirmPassword
  });

  useEffect(() => {
    if (passwordValue && confirmPasswordValue && passwordValue !== confirmPasswordValue) {
      setPasswordsNotMatch(true);
    } else {
      setPasswordsNotMatch(false);
    }
  }, [passwordValue, confirmPasswordValue]);

  return (
    <>
      <PasswordField name={formFieldNames.password} label={passwordLabel} />

      <PasswordField
        name={formFieldNames.confirmPassword}
        label={confirmPasswordLabel ?? t('auth.confirmPassword')}
        helperText={passwordsNotMatch ? t('password_not_match') : ''}
        error={passwordsNotMatch}
      />
    </>
  );
};
